import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { SiteCustomizationProvider } from './context/SiteCustomizationContext';

import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* SocketProvider utilise useAuth() ⇒ AuthProvider doit l’englober */}
      <AuthProvider>
        <SocketProvider>
          <SiteCustomizationProvider>
            <App />
          </SiteCustomizationProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
